export default __webpack_public_path__ + "static/media/GraveyardMap.a165bc1f.jpg";